// import React, { useContext, useEffect } from "react";
// import "../Navbar/Navbar.scss";
// import "../Sidebar/Sidebar.scss";
// import { useState } from "react";
// import Offcanvas from "react-bootstrap/Offcanvas";
// import brand from "../../../Assets/Images/brand-logo.png";
// import "../Sidebar/responsiveSidebar.scss";
// import { Link, useNavigate } from "react-router-dom";
// import { CgProfile } from "react-icons/cg";
// import axios from "axios";
// import Dropdown from "react-bootstrap/Dropdown";
// import { API_BASE_URL } from "../../../utils/index";
// import DashBoardIteams from "../../SidebarItems/DashBoardIteams";
// import ProductsItems from "../../SidebarItems/ProductsItems";
// import CouponItems from "../../SidebarItems/CouponItems";
// import ShippingItems from "../../SidebarItems/ShippingItems";
// import MasterItems from "../../SidebarItems/MasterItems";
// import userContext from "../../UseContext/UseContext";
// import { BurgerArrow } from 'react-burger-menu';

// const Navbar = ({ handleClick }) => {
//   const [show, setShow] = useState(false);
//   const handleClose = () => setShow(false);
//   const handleShow = () => setShow(true);
//   const [menuOpen, setmenuOpen] = useState(false);

//   const navigate = useNavigate();
//   const logOutContext = useContext(userContext);
//   const [user, setUser] = useState(null);
//   useEffect(() => {
//     const adminId = localStorage.getItem("accessToken");



//     if (!adminId) {
//       console.log("@###############@@@@@@@@@@@@@@@@@@############# inside the if condition admin  not found ")
//       navigate("/login");
//       return;
//     }
//     console.log("@###############@@@@@@@@@@@@@@@@@@############# 1st line")
//     const headers = {
//       Authorization: `Bearer ${adminId}`,
//       "Content-Type": "application/json",
//     };

//     axios
//       .get(`${API_BASE_URL}/admin/myprofile`, {
//         headers,
//       })
//       .then((result) => {

//         console.log(result.data.data, "@###############@@@@@@@@@@@@@@@@@@#############")
//         setUser(result.data.data);
//       })
//       .catch((error) => {
//         console.log("error in profile api", error.response.status);
//         if (error.response.status === 401) {
//           navigate("/login");
//         }
//       });
//   }, []);



//   return (
//     <div className="dashboard-nav px-4">
//       <div className="nav-menu">
//         <svg
//           onClick={handleClick}
//           className="fs-5"
//           xmlns="http://www.w3.org/2000/svg"
//           height="1em"
//           viewBox="0 0 448 512"
//         >
//           <path d="M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z" />
//         </svg>

//       </div>

//       <div className="responsive-sidebar">
//         <svg
//           onClick={handleShow}
//           className="fs-5"
//           xmlns="http://www.w3.org/2000/svg"
//           height="1em"
//           viewBox="0 0 448 512"
//         >
//           <path d="M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z" />
//         </svg>

//         <Offcanvas show={show} onHide={handleClose} backdrop="static">
//           <Offcanvas.Header closeButton>
//             <Offcanvas.Title className="text-dark"></Offcanvas.Title>
//           </Offcanvas.Header>
//           <Offcanvas.Body className="text-danger">
//             <img
//               src={brand}
//               alt="brand_logo"
//               className="responsive-sidebar-logo"
//             />

//             <ul className="sidebar-items">
//               <DashBoardIteams />

//               <ProductsItems />

//               <CouponItems />

//               <ShippingItems />

//               <MasterItems />
//             </ul>
//           </Offcanvas.Body>
//         </Offcanvas>
//       </div>

//       <div className="d-flex align-iteam-center">
//         <Link to="/profilepage" className="user">
//           {/* <img className="user-image mx-2" src={userImage} /> */}
//         </Link>

//         <Dropdown className="user">
//           <Dropdown.Toggle
//             id="dropdown-button-dark-example1"
//           // variant="secondary"
//           >
//             <div className="user-name">
//               {/* {product ? product.firstName : "Loading..."} */}


//               {user
//                 ? `${user.firstName} ${user.lastName}`
//                 : "User"}            </div>

//                 <Link to="/profilepage">

//             <CgProfile  className="mx-2 text-dark fs-4" />
//                 </Link>
//           </Dropdown.Toggle>
//           {/* <div className="w-100 d-flex align-items-center justify-content-center">
//               <button
//                 className="py-1 px-2 rounded  logout"
//                 onClick={handleLogout}
//               >
//                 Log Out
//               </button>
//             </div> */}

//         </Dropdown>
//       </div>
//     </div>
//   );
// };

// export default Navbar;
import React, { useContext, useEffect, useState } from "react";
import "../Navbar/Navbar.scss";
import "../Sidebar/Sidebar.scss";
import Offcanvas from "react-bootstrap/Offcanvas";
import brand from "../../../Assets/Images/brand-logo.png";
import "../Sidebar/responsiveSidebar.scss";
import { Link, useNavigate } from "react-router-dom";
import { CgProfile } from "react-icons/cg";
import axios from "axios";
import Dropdown from "react-bootstrap/Dropdown";
import { API_BASE_URL } from "../../../utils/index";
import DashBoardIteams from "../../SidebarItems/DashBoardIteams";
import ProductsItems from "../../SidebarItems/ProductsItems";
import CouponItems from "../../SidebarItems/CouponItems";
import ShippingItems from "../../SidebarItems/ShippingItems";
import MasterItems from "../../SidebarItems/MasterItems";
import userContext from "../../UseContext/UseContext";

const Navbar = ({ handleClick }) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [user, setUser] = useState(null);

  const navigate = useNavigate();
  const logOutContext = useContext(userContext);

  const adminId = localStorage.getItem("accessToken");
  // console.log(adminId, "@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@")
  useEffect(() => {

    if (!adminId) {
      console.log("Admin not found, redirecting to login");
      navigate("/login");
      return;
    }

    console.log("Making API request to fetch profile");

    const headers = {
      Authorization: `Bearer ${adminId}`,
      "Content-Type": "application/json",
    };

    axios
      .get(`${API_BASE_URL}/admin/myprofile`, { headers })
      .then((result) => {
        console.log("Profile fetched successfully:", result.data.data);
        setUser(result.data.data);
      })
      .catch((error) => {
        console.error("Error in profile API request:", error);
        if (error.response) {
          console.log("Error status code:", error.response.status);
         
        }
      });
  }, []);

  return (
    <div className="dashboard-nav px-4">
      <div className="nav-menu">
        <svg
          onClick={handleClick}
          className="fs-5"
          xmlns="http://www.w3.org/2000/svg"
          height="1em"
          viewBox="0 0 448 512"
        >
          <path d="M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z" />
        </svg>
      </div>

      <div className="responsive-sidebar">
        <svg
          onClick={handleShow}
          className="fs-5"
          xmlns="http://www.w3.org/2000/svg"
          height="1em"
          viewBox="0 0 448 512"
        >
          <path d="M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z" />
        </svg>

        <Offcanvas show={show} onHide={handleClose} backdrop="static">
          <Offcanvas.Header closeButton>
            <Offcanvas.Title className="text-dark"></Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body className="text-danger">
            <img
              src={brand}
              alt="brand_logo"
              className="responsive-sidebar-logo"
            />

            <ul className="sidebar-items">
              <DashBoardIteams />
              <ProductsItems />
              <CouponItems />
             
              <MasterItems />
            </ul>
          </Offcanvas.Body>
        </Offcanvas>
      </div>

      <div className="d-flex align-iteam-center">
        <Link to="/profilepage" className="user">
          {/* <img className="user-image mx-2" src={userImage} /> */}
        </Link>

        <Dropdown className="user">
          <Dropdown.Toggle id="dropdown-button-dark-example1">
            <div className="user-name">
              {user ? `${user.firstName} ${user.lastName}` : "User"}
            </div>

            <Link to="/profilepage">
              <CgProfile className="mx-2 text-dark fs-4" />
            </Link>
          </Dropdown.Toggle>
        </Dropdown>
      </div>
    </div>
  );
};

export default Navbar;
